import { Attr, BelongsToMany, Str } from 'pinia-orm/dist/decorators'
import Permission from 'modules/Permission/Permission'
import RoleHasPermission from 'modules/RoleHasPermission/RoleHasPermission'
import { Model } from 'pinia-orm'

export default class Role extends Model {
  static override entity = 'roles'

  // Fields
  @Attr('') declare id: string

  @Str('') declare name: string
  @Str('') declare guard_name: string

  // Relationships
  @BelongsToMany(() => Permission, () => RoleHasPermission, 'role_id', 'permission_id') declare permissions: Permission[]
}
